
import { Subscription, interval } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SwUpdate } from '@angular/service-worker'
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})

export class UpdateService {

    constructor(public updates: SwUpdate) {
      if (updates.isEnabled) {
       
          updates.checkForUpdate()
        interval(600 * 600 * 60).subscribe(() => updates.checkForUpdate()
          .then(() => console.log('checking for updates')));
      }
    }
  
    public checkForUpdates(): void {
      if (this.updates.isEnabled) {

      this.updates.versionUpdates.subscribe
      (event => {
        this.promptUser()
    });
  }
    }
  
    private promptUser(): void {
      this.updates.activateUpdate().then(() => document.location.reload()); 
    }


}